import { render, staticRenderFns } from "./xljk.vue?vue&type=template&id=52357c6b&scoped=true"
import script from "./xljk.vue?vue&type=script&lang=js"
export * from "./xljk.vue?vue&type=script&lang=js"
import style0 from "./xljk.vue?vue&type=style&index=0&id=52357c6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52357c6b",
  null
  
)

export default component.exports